import { render, staticRenderFns } from "./NotesThread.vue?vue&type=template&id=2e676f61&scoped=true&"
import script from "./NotesThread.vue?vue&type=script&lang=js&"
export * from "./NotesThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e676f61",
  null
  
)

export default component.exports